module.exports = __webpack_public_path__ + "img/flat-bag.173376cf.png";